import { getNumbersWithDecimalPlaces } from '../money';

/**
 * Manuplate array of items to desirable table data.
 * @param {array} values
 * @returns {array}
 */
export function modifyItems(values) {
  return values.map((item) => {
    var data = Object.assign({ id: item._id }, item);
    let temp = {};

    if (item?.cate_id === 'send' && item.hasOwnProperty('sends')) {
      data.amount = item?.sends[0]?.amount;
      data.address = item?.sends[0]?.to_addr;
      temp.token = (item?.sends[0]?.token_id || []).length < 6 ? item.sends[0]?.token_id : '';
    }

    if (item?.cate_id === 'receive') {
      data.amount = item?.receives[0]?.amount;
      data.address = item?.receives[0]?.from_addr;
      temp.token = (item?.receives[0]?.token_id || []).length < 6 ? item.sends[0]?.token_id : '';
    }

    if (item?.tx) {
      if (item?.tx?.value && item?.tx?.value > 0) {
        data.amount = item.tx.value;
      }
      data.eth_gas_fee = getNumbersWithDecimalPlaces(item.tx.eth_gas_fee, 4);
      data.usd_gas_fee = getNumbersWithDecimalPlaces(item.tx.usd_gas_fee, 4);
    }

    if (data?.amount) {
      data.amount = getNumbersWithDecimalPlaces(data.amount, 4) + ' ' + temp?.token || '';
    }

    return data;
  });
}
